export default __webpack_public_path__ + "static/media/factura7.e20602b4.pdf";